import React from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid/v4'
import Button from 'gatsby-theme-leshen/src/components//Button'
import Input from 'gatsby-theme-leshen/src/components/Form/Input'
import * as Styled from 'gatsby-theme-leshen/src/components/Form/Form.styles'
import Select from './Select'

const FormControl = ({
  id,
  label,
  type,
  handleBlur,
  handleChange,
  errorMessage,
  touched,
  ...props
}) => {
  const hasError = Boolean(errorMessage) && Boolean(touched)
  const isTouchedAndValid = !errorMessage && Boolean(touched)

  // @TODO re-declaring this function each time the component is used?
  const determineField = () => {
    switch (type) {
      case 'hidden':
        return <Input type="hidden" id={id} {...props} />

      case 'submit':
        return (
          <div>
            <Button type="submit" id={id} {...props}>
              {label}
            </Button>
          </div>
        )

      case 'singleSelect':
        return (
          <div>
            <Styled.Label
              htmlFor={id}
              hasError={hasError}
              isTouchedAndValid={isTouchedAndValid}
            >
              <div className="label-text">{label}</div>
              <Select
                type={type}
                id={id}
                placeholder={label}
                onBlur={handleBlur}
                hasError={hasError}
                isTouchedAndValid={isTouchedAndValid}
                onChange={handleChange}
                {...props}
              />
              {hasError && (
                <Styled.Message hasError={hasError}>
                  {errorMessage}
                </Styled.Message>
              )}
            </Styled.Label>
          </div>
        )

      default:
        return (
          <div>
            <Styled.Label
              htmlFor={id}
              hasError={hasError}
              isTouchedAndValid={isTouchedAndValid}
            >
              <div className="label-text">{label}</div>
              <Input
                type={type}
                id={id}
                placeholder={label}
                onBlur={handleBlur}
                hasError={hasError}
                isTouchedAndValid={isTouchedAndValid}
                onChange={handleChange}
                {...props}
              />
              {hasError && (
                <Styled.Message hasError={hasError}>
                  {errorMessage}
                </Styled.Message>
              )}
            </Styled.Label>
          </div>
        )
    }
  }

  return determineField()
}

FormControl.defaultProps = {
  id: uuid(),
  type: 'text',
  placeholder: '',
  label: '',
  required: true,
}

FormControl.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'string',
    'email',
    'text',
    'hidden',
    'range',
    'checkbox',
    'tel',
    'radio',
    'number',
    'url',
    'singleSelect',
    'submit',
  ]),
}

export default FormControl
